import React from "react";
import { node, bool } from "prop-types";
import classNamesMaker from "classnames";
import { useModal } from "#library/components/Modal/ModalManagement/ModalContext";
import styles from "#library/components/Modal/modal.module.css";
export var ModalHeader = function ModalHeader(_ref) {
  var children = _ref.children,
    _ref$hasIcon = _ref.hasIcon,
    hasIcon = _ref$hasIcon === void 0 ? false : _ref$hasIcon;
  var _useModal = useModal(),
    type = _useModal.type,
    isFooterSticky = _useModal.isFooterSticky;
  var stylesHeader = classNamesMaker(styles["jds-Modal__header"], type && styles["jds-Modal__header--".concat(type)], !hasIcon && styles["jds-Modal__header--withoutIcon"], isFooterSticky && styles["jds-Modal__header--stickyFooter"]);
  return /*#__PURE__*/React.createElement("header", {
    className: stylesHeader
  }, children);
};
ModalHeader.propTypes = {
  children: node,
  hasIcon: bool
};